(function () {
  const form = document.getElementById("lr-form");
  if (!form) return;

  const alertBox = document.getElementById("lr-alert");
  const correlativoInput = document.getElementById("lr_correlativo");
  const correlativoPreview = document.getElementById("lr-correlativo-preview");

  function showAlert(type, msg) {
    alertBox.className = "lr-alert " + (type === "ok" ? "ok" : "err");
    alertBox.textContent = msg;
    alertBox.style.display = "block";
    alertBox.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function serializeForm(formEl) {
    const data = new FormData(formEl);
    const obj = {};
    for (const [k, v] of data.entries()) obj[k] = v;
    return obj;
  }

  function toQuery(obj) {
    const params = new URLSearchParams();
    Object.keys(obj).forEach((k) => {
      const val = obj[k];
      if (val !== undefined && val !== null && String(val).trim() !== "") {
        params.append(k, val);
      }
    });
    return params.toString();
  }

  // JSONP helper (evita CORS)
  function jsonpRequest(url) {
    return new Promise((resolve, reject) => {
      const cbName = "lr_cb_" + Date.now() + "_" + Math.floor(Math.random() * 1000);

      window[cbName] = (data) => {
        resolve(data);
        cleanup();
      };

      const script = document.createElement("script");
      script.src = url + (url.includes("?") ? "&" : "?") + "callback=" + encodeURIComponent(cbName);

      script.onerror = () => {
        reject(new Error("No se pudo conectar con el servidor del Libro de Reclamaciones."));
        cleanup();
      };

      function cleanup() {
        try { delete window[cbName]; } catch (_) { window[cbName] = undefined; }
        if (script.parentNode) script.parentNode.removeChild(script);
      }

      document.body.appendChild(script);
    });
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    // Verifica endpoint
    if (!window.LR_ENDPOINT || window.LR_ENDPOINT.includes("PEGA_AQUI")) {
      showAlert("err", "Falta configurar el endpoint del Libro de Reclamaciones (Apps Script).");
      return;
    }

    // Validación HTML5
    if (!form.checkValidity()) {
      showAlert("err", "Revisa los campos obligatorios antes de enviar.");
      return;
    }

    // Botón
    const btn = form.querySelector("button[type='submit']");
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Enviando...";

    try {
      const payload = serializeForm(form);

      // IMPORTANTE:
      // Esto envía por GET al Apps Script con doGet (JSONP)
      const qs = toQuery(payload);
      const url = window.LR_ENDPOINT + (window.LR_ENDPOINT.includes("?") ? "&" : "?") + qs;

      const json = await jsonpRequest(url);

      if (!json || json.ok !== true) {
        throw new Error((json && json.error) ? json.error : "Respuesta inválida del servidor.");
      }

      // Mostrar correlativo
      correlativoInput.value = json.correlativo || "";
      correlativoPreview.textContent = json.correlativo || "—";

      showAlert(
        "ok",
        `¡Recibido! Tu reclamo/queja fue registrado con el N° ${json.correlativo}. Revisa tu correo para la constancia.`
      );

      // Reset
      form.reset();

    } catch (err) {
      showAlert("err", "No se pudo enviar. Intenta nuevamente o contáctanos por WhatsApp/Correo. " + err.message);
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
})();
